import "core-js/modules/es.object.to-string";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import cookie from '../util/cookie';
import request from './request';
export function getMainUserInfo() {
  var loginType = cookie.get('main_login');
  if (!loginType) return Promise.resolve(null);
  var userInfo = {
    type: loginType,
    nick: cookie.get("".concat(loginType, "_nick")),
    headurl: cookie.get("".concat(loginType, "_head"))
  };

  try {
    userInfo.nick = decodeURIComponent(userInfo.nick);
    userInfo.headurl = decodeURIComponent(userInfo.headurl);
  } catch (e) {}

  return Promise.resolve(userInfo);
}
export function getPayVip() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (param && param.service === 'kid') {
    return getKidPayVip();
  }

  return request('//vip.video.qq.com/fcgi-bin/comm_cgi?name=payvip&cmd=1&getannual=1&otype=json', _objectSpread({
    geticon: 1,
    // 身份位改造，通过此字段同步回来
    getsvip: 1,
    // 获取SVIP信息
    g_tk: ''
  }, param), {
    dataType: 'jsonp',
    timeout: 5000
  }).then(function (res) {
    if (res && res.result && res.result.code === 0) {
      return res;
    } else {
      throw res.result;
    }
  }).catch(function (e) {
    var err = {
      code: e.code || -999,
      msg: e.msg || '[request] payvip error'
    };
    throw err;
  });
} // 获取小企鹅会员信息

function getKidPayVip() {
  var options = {
    type: 'GET',
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    }
  };
  return request('https://vip.video.qq.com/rpc/trpc.kidsvip.getvipinfo.KidsVipInfoService/KidsVipGetInfo', {}, options).then(function (result) {
    try {
      var res = JSON.parse(result);

      if (res && res.result && res.result.code === 0) {
        return res;
      } else {
        throw res.result;
      }
    } catch (e) {
      throw e;
    }
  }).catch(function (e) {
    var err = {
      code: e.code || -999,
      msg: e.msg || '[request] payvip error'
    };
    throw err;
  });
}